module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"hd2":"セミナー内容","success":[":ありがとうございます！: :情報の送信が完了しました。:",":メールボックスを::ご確認ください。:"],"submitted_title":"セミナー申し込み完了"}}')
  delete Component.options._Ctor
}
